import React, { createContext, useContext, useCallback } from 'react';
import { useSubscription } from '../hooks/useSubscription';

interface SubscriptionContextType {
  subscription: any;
  loading: boolean;
  isPremium: boolean;
  isPro: boolean;
  isBasic: boolean;
  isFree: boolean;
  refetch: () => void;
  forceRefresh: () => void;
}

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const subscriptionData = useSubscription();

  return (
    <SubscriptionContext.Provider value={subscriptionData}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscriptionContext = () => {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscriptionContext must be used within a SubscriptionProvider');
  }
  return context;
};